module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre",
    attrs: {
      "id": "pgepubid00007"
    }
  }, [_vm._v("CONTENTS.")]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('table', {
    staticClass: "calibre7",
    attrs: {
      "border": "0",
      "cellpadding": "14",
      "cellspacing": "0",
      "summary": ""
    }
  }, [_c('tbody', {
    staticClass: "calibre8"
  }, [_c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("chapter")]), _vm._v(".")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("page")]), _vm._v(".")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("I.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_vm._v("“"), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("Railroad Blake")]), _vm._v("”")]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0005"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("II.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("A Race for the Railroad Cup")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0006#CHAPTER_II"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("III.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("A Cruel Accusation")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0007#CHAPTER_III"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("IV.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Starting into the World")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0008#CHAPTER_IV"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("V.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Choosing a Career")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0009#CHAPTER_V"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("VI.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Smiler, the Railroad Dog")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0010#CHAPTER_VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("VII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Rod, Smiler, and the Tramp")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0011#CHAPTER_VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("VIII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Earning a Breakfast")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0012#CHAPTER_VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("IX.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Gaining a Foothold")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0013#CHAPTER_IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("X.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("A Thrilling Experience")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0014#CHAPTER_X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("XI.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("A Battle with Tramps")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0015#CHAPTER_XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("XII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Bound, Gagged, and a Prisoner")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0016#CHAPTER_XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("XIII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("How Brakeman Joe was Saved")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0017#CHAPTER_XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("XIV.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Superintendent Investigates")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0018#CHAPTER_XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("XV.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Smiler to the Rescue")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0019#CHAPTER_XV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("XVI.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Snyder Appleby’s Jealousy")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0020#CHAPTER_XVI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("XVII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Rod as a Brakeman")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0021#CHAPTER_XVII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("XVIII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Working for a Promotion")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0022#CHAPTER_XVIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("XIX.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Express Special")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0023#CHAPTER_XIX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("126")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("XX.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Trouble in the Money Car")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0024#CHAPTER_XX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("135")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("XXI.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Over the Top of the Train")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0025#CHAPTER_XXI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("142")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("XXII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Stop Thief!")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0026#CHAPTER_XXII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("148")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("XXIII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("A Race of Locomotives")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0027#CHAPTER_XXIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("155")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("XXIV.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Arrested on Suspicion")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0028#CHAPTER_XXIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("161")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("XXV.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Train Robber Learns of Rod’s Arrest")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0029#CHAPTER_XXV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("168")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("XXVI.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("A Welcome Visitor")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0030#CHAPTER_XXVI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("174")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("XXVII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Sheriff is Interviewed")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0031#CHAPTER_XXVII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("180")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("XXVIII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Light Dawns upon the Situation")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0032#CHAPTER_XXVIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("186")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("XXIX.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("An Arrival of Friends and Enemies")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0033#CHAPTER_XXIX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("192")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("XXX.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Where are the Diamonds?")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0034#CHAPTER_XXX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("198")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("XXXI.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("One Hundred Miles an Hour!")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0035#CHAPTER_XXXI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("205")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("XXXII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Snatching Victory from Defeat")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0036#CHAPTER_XXXII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("211")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("XXXIII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("A Wrecking Train")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0037#CHAPTER_XXXIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("217")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("XXXIV.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Rod Accepts the Legacy")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0038#CHAPTER_XXXIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("223")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("XXXV.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Firing on Number 10")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0039#CHAPTER_XXXV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("231")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("XXXVI.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Only Chance of Saving the Special")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0040#CHAPTER_XXXVI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("237")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("XXXVII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Independence or Pride")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0041#CHAPTER_XXXVII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("245")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("XXXVIII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("A Moral Victory")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0042#CHAPTER_XXXVIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("252")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_vm._v("XXXIX.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Snyder is Forgiven")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0043#CHAPTER_XXXIX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("258")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a61bab10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0003.vue
// module id = 63
// module chunks = 0